export default "__VITE_ASSET__DMVXOzk0__"